
export default function useLocalStore<T>(storeKey: string, dflt: T) {
  const store = (s: T) => {
    localStorage.setItem(storeKey, JSON.stringify(s));
  }
  
  const load = (): T => {
    const data = localStorage.getItem(storeKey);
    if (data !== null) return JSON.parse(data) as T;
    return dflt;
  }

  return { store, load }
}
  
  